<template>
	<div id="chaindetail" :class="userdata.groupType != 1? 'userFreeWaterMark' : ''">
		<leftnav></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<el-dialog class="localChain chanyelian" title="" :visible.sync="isShowFreeUserTips" width="648px" top="25vh">
				<freeUserTips :type="freeUserType" :bgtype="0" :isShowDownFile="true"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<div class="chain-detail gov_chain-detail">
					<div class="chain_detai_top ">
						<div class="chain-title-box">
							<h2 class="chain-title oh">
								<div class="chain-title-sm fl">{{ calCuData.text }}-{{ chaininformation.title }}</div>
								<el-tooltip class="item smartTip-text" effect="light" placement="top-start"
									style="font-size: 20px;" v-show="calCuData.type != userdata.currentCity.type">
									<i class="el-icon-question" style="color:cornflowerblue;margin-left: 5px;"></i>
									<div slot="content" class="list_tips">
										<p>产业图谱：产业节点中标注为“<em class="redfont">*</em>”的企业为所属区县的企业。</p>
									</div>
								</el-tooltip>
								<div class="display-inline-block ml-4 font-18 font-normal"><vedioTips :type="2"></vedioTips></div>
								<!-- <span :class="chaininformation.collectId == 0?'collectbtn add fr':'collectbtn remove fr'" @click="collectFun()">{{chaininformation.collectId == 0?'+添加关注':'取消关注'}}</span> -->
								<span class="enterprise-download fr" @click="downloadWord()"><i
										class="el-icon-download"></i>下载产业链分析报告</span>
							</h2>
							<div class="chain_top_infor">
								<div class="fr poinNumber">共 <strong class="basefont">{{ chaininformation.nodeNum
								}}</strong>个产业节点， <strong class="basefont">{{ chaininformation.enterpriseNum
}}</strong> 家企业</div>
								<!--<div class="fr poinNumber">共 <strong class="basefont">30</strong>个产业节点，<strong class="basefont"> 6890</strong> 家企业</div>-->
								<div class="fr chainpoint" v-if="flag">
									<!-- <span class="orangebd bdbox " :node="nodetypearry.jian" onclick="keychainpoint(this,'#f60')">建链</span> -->
									<span class="orangebd bdbox " :node="nodetypearry.qiang"
										onclick="keychainpoint(this,'#f60')">强链</span>
									<span class="defaultbd bdbox " :node="nodetypearry.bu"
										onclick="keychainpoint(this,'#5cb85c')">补链</span>
								</div>

							</div>
						</div>
						<!--放置产业链内容处 <div id="chain-con"><img src="/public/imagesv2/chaindetail.png" /></div>-->
						<div class="chain-graph-wrap">
							<chain ref="chain" :graphData="chaininformation.graphData" :nodelistprops="nodeListcom"
								v-if="flag" type="local"></chain>
							<div></div>
						</div>
						<div class="chain_RelatedReport" v-show="reportList.length > 0">
							<h2 class="chain_title2">相关报告</h2>
							<ul class="chain_rReport">
								<li :key="i" v-for="(list, i) in reportList" :data="list.id"><i></i><a target="_blank"
										:href="list.url + '&token=' + userdata.token">{{ list.title }}</a></li>
								<li><i></i><a target="_blank"
										:href="chaininformation.moreReport + '&token=' + userdata.token">更多相关报告>></a></li>

							</ul>
						</div>
						<div class="chain_map" v-show="mapdata.length != 0">
							<div class="poabox">
								<div id="areaRankBar"></div>
								<div id="areaMap"></div>
							</div>
							<h4 class="title chain_map_title fl">{{ calCuData.text }}{{ chaininformation.title }}地图</h4>
							<div v-html="chaininformation.nodeMap"></div>
						</div>
						<div class="chain_detail_bot">
							<div class="chain_table_box">
								<h2 class="chain_title1" v-show="chaininformation.companyList != ''">产业链各细分领域公司</h2>
								<table border="0" cellspacing="0" cellpadding="0" class="chain_table centerpage1"
									v-show="chaininformation.companyList != ''">
									<!-- 该备注文字可删除  data-market是放在对应节点名称的第一个tr上 例如 <tr class="node-5234" style="background: rgb(252, 253, 255);" data-market='[{"name":"市场规模","data":[{"name":"2019","datay":"130~250亿元"},{"name":"2020","datay":"180~340亿元"}]},{"name":"市场机会评估","data":[{"name":"市场潜力","datay":"中等"},{"name":"发展阶段","datay":"成长期"},{"name":"机会属性","datay":"中等"},{"name":"政策门槛","datay":"一般"},{"name":"竞争门槛","datay":"较高"},{"name":"技术门槛","datay":"中等"},{"name":"资金门槛","datay":"较高"}]},{"name":"招商机会分析","data":[{"name":"适合区域","datay":"一、二、三、四线城市"},{"name":"招商时机","datay":"一般"},{"name":"推荐程度","datay":"适中"}]}]'>-->
									<!-- 该备注文字可删除  如果后台没有设置data-market的属性时，data-market="", 当鼠标移上节点时显示节点重点公司内容  -->
									<tbody v-html="chaininformation.companyList"> </tbody>
								</table>
								<!-- 版权为深圳市中投顾问股份有限公司所有， -->
								<p class="chain_footer"><em class="redfont">*</em> 本内容已申请TSA数字版权保护，未经授权，不得转载！
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import $ from "jquery";
import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"
import { pinyin } from 'pinyin-pro';
let cityShortNameData = require('../../../public/map/geo.json');  //引入json文件
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'localChaindetail',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	components: {
		freeUserTips
	},
	data() {
		return {
			id: 0,
			areatype: "city",
			calCuData: { id: 11, name: '北京', type: 'city' },
			chaininformation: { collectId: 0 },
			curindex: 1, nodeListcom: [],
			reportList: [],
			userdata: { currentCity: { text: "", type: "", id: 0 } },
			flag: false, //echarts渲染的开关
			mapdata: [],
			companyCount: '',
			nodetypearry: { jian: [], qiang: [], bu: [] },
			nodeCount: '',
			coreNode: '',
			subChain: '',
			subChainId: '',
			companyList: '',
			title: "",
			graphData: '',
			importantCompany: '',
			nodeMap: '',
			nodeScoreTable: '',
			provinceMap: [],
			showSubChain: false,
			sTitle: '',
			report: '',
			category: '',
			isShowFreeUserTips: false,
			freeUserType: 2,
			public_tooltip: {
				trigger: 'axis',
				backgroundColor: 'rgba(255,255,255,0.9)',
				borderColor: '#ddd',
				borderWidth: '1',
				textStyle: {
					color: '#000',
					fontSize: 14,
				}
			},
			mapurl: 'map/city/321200.json',
			mapUnit: '家公司',
			colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
		}
	},
	beforeCreate() {
		// console.log('beforeCreate');
		this.bus.$emit('loading', true);
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
	},
	mounted() {
		this.getuserinfor();
		if (this.userdata.edition < 1) {
			var _this = this;
			alert('升级版本后即可查看本页面,自动跳转');
			setTimeout(function () {
				_this.routerself('/totalEnterprises');
			}, 1000)
			return;
		}
		this.bus.$emit('loading', true);
		this.calcuCityType();
		if (this.userdata.token) {
			// this.mapurl =  'map/'+this.userdata.currentCity.type+'/'+this.userdata.currentCity.mapname+'.json';
			if (this.areatype == 'city') {
				this.mapurl = 'map/' + this.userdata.currentCity.type + '/' + this.userdata.currentCity.mapname + '.json';
			} else {
				this.mapurl = 'map/province' + '/' + this.convertToPinyin(this.userdata.provinceText) + '.json';
			}

		}
	},
	methods: {
		convertToPinyin(chineseText) {
			let removechineseText = this.citynameremove(chineseText); //剔除省、自治区等字
			let pinyinText = pinyin(removechineseText, { toneType: 'none' });//转换拼音
			let relpPinyinText = pinyinText.replace(/\s/g, '');;//删除转换拼音后的空格
			// console.log(chineseText,removechineseText,pinyinText,relpPinyinText)
			return relpPinyinText;
		},
		downloadWord() {
			if (this.userdata.isFree || (this.userdata.groupType == 0 && !this.chaininformation.download)) { //免费无下载权限，试用账号需要授权download才能下载，产业链权限弹窗提示
				this.freeUserType = 2;
				this.isShowFreeUserTips = true;
				return;
			} else if (this.userdata.groupType == 1 && !this.chaininformation.download) {//正式账号无下载产业链权限弹窗提示
				this.freeUserType = 3;
				this.isShowFreeUserTips = true;
				return;
			}
			var that = this;
			var fileName = this.chaininformation.title + '.docx';
			try {
				//1请求后台获取文档流
				that.bus.$emit('loading', true);
				this.$axios.get(this.$api.cyl.chain.download() + '?chainId=' + this.id, {
					headers: {
						AuthToken: this.userdata.token
					},
					responseType: 'blob',//*响应类型需要是blob
				}).then(function (res) {
					// console.log('后端返回的文档流',res)
					const blob = res.data;
					//2 创建一个url 对象，并将blob实例作为参数传入，这样href的值就是以blob开头的一个文件流下载链接
					const url = window.URL.createObjectURL(blob);
					//3创建下载链接
					const a = document.createElement('a');
					a.href = url;
					a.download = fileName || Date.now();
					a.style.display = 'none';
					a.click();
					//4避免占用销毁创建的链接
					document.body.removeChild(a)

				}).catch(function (error) {
					// 请求失败处理 console.log(error);
				});
			} catch (error) {
				console.error('Error:', error);
				_this.$message({
					type: 'error',
					message: error,
				});
			} finally {
				that.bus.$emit('loading', false);
			}
		},
		calcuCityType() {
			this.areatype = this.$route.query.type ? this.$route.query.type : 'city';
			if (this.areatype == 'city') {
				this.calCuData = { id: this.userdata.currentCity.id, text: this.userdata.currentCity.text, type: this.userdata.currentCity.type };
			} else {
				this.calCuData = { id: this.userdata.province, text: this.userdata.provinceText, type: 'province' };
			}
			this.loadData();
		},
		MainScopeShowMore() {
			$('.chain-table-main-scope').each(function () {
				var fontlength = $(this).html().length;
				$(this).attr('data-num', fontlength);
				if (fontlength > 134) {
					$(this).prepend('<span class="showmorebtn">更多文字信息……</span>')
				}
			});
			$('.showmorebtn').click(function () {
				$(this).parent('.chain-table-main-scope').toggleClass('showmore');
			})
		},
		getuserinfor() {
			this.userdata = this.getuseriformation();
			this.calCuData = this.getCalcuCity(this.userdata);
		},
		loadData() {
			//this.id = this.$route
			this.id = this.$route.query.id;
			var _this = this;
			if (!this.id) {
				return;
			}
			//获取产业链详情信息
			console.log(this.$api.cyl.localchain.detail() + '?id=' + this.id)
			this.$axios.get(this.$api.cyl.localchain.detail() + '?id=' + this.id + '&areaId=' + this.calCuData.id, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				// console.log('获取产业链详情信息',res)
				if (res.data.success) {
					let datar = res.data.data;
					console.log('chaininfomation', res.data);
					_this.chaininformation = datar;
					_this.chaininformation.companyList = '<tr><th style="line-height:48px;">细分领域</th><th>企业名称</th><th>注册资本</th><th>所属城市</th><th style="width:220px">详细地址</th><th style="width:500px">经营范围</th></tr>' + datar.companyList;
					_this.reportList = datar.reportList;
					document.title = datar.title;
					_this.nodeListcom = datar.nodeList;
					for (var i = 0; i < datar.nodeList.length; i++) {
						if (datar.nodeList[i].nodeType == '补链') {
							_this.nodetypearry.bu.push(datar.nodeList[i].nodeId)
						} else if (datar.nodeList[i].nodeType == '强链') {
							_this.nodetypearry.qiang.push(datar.nodeList[i].nodeId)
						} else if (datar.nodeList[i].nodeType == '建链') {
							_this.nodetypearry.jian.push(datar.nodeList[i].nodeId);
						}


					}
					let areaMap = datar.areaMap;
					for (var key in areaMap) {
						if (areaMap.hasOwnProperty(key)) {
							// console.log(areaMap[key]);
							for (var i = 0; i < cityShortNameData.length; i++) {  //因为后台传给前端的数据是市区的简称，需要转换成全称才好匹配地图
								if (areaMap[key].name == cityShortNameData[i].shortname) {
									areaMap[key].shortname = areaMap[key].name;
									areaMap[key].name = cityShortNameData[i].name;
								}

							}
							_this.mapdata.push(areaMap[key]);
						}
					}
					console.log('地图数据', _this.mapdata);
					_this.flag = true;

					setTimeout(() => {
						_this.MainScopeShowMore();
						_this.mapGeo('areaMap', _this.mapdata);
						_this.areaRankBarFun('areaRankBar',_this.mapdata);//柱状图
						_this.bus.$emit('loading', false);

					}, 1000);

				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//柱状图
		areaRankBarFun(el,data) {
				data = this.sortKey(data,'value'); //讲数据从大到小排序
				var chart = echarts.init(document.getElementById(el));
				var _this = this,
					xline = [],
					seriesline = [];
				var datalen = data.length - 1;
				for (var i = 0; i < data.length; i++) {
					xline.push(data[datalen - i].name);
					seriesline.push(data[datalen - i].value);
				};
				console.log(data,xline,seriesline)
				var option = {
					title: {
						// text:_this.cityname+'重点产业',
						text: '',
						right: 0,
						bottom: 20,
						textStyle: {
							color: '#333',
							fontSize: 16
						}
					},
					tooltip: {
						formatter: "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff'></span>{b}：{c} "+_this.mapUnit
					},
					color: _this.colors,
					grid: { containLabel: true },
					label: {
						show: true,
						position: 'right',
						valueAnimation: true,
						color:_this.colors,
						formatter: '{@score}'
					},
					xAxis: {
						position: 'top' ,// 设置横坐标在顶部
						type: 'value',
						axisTick: {
							show: false
						},
						splitLine: {
							show: false
						},
						axisLabel: {
							fontSize: 13,
							color: '#ccc',  
						},
						interval: 1000, // 只显示最大和最小坐标
						minIterval: 1,
					},
					yAxis: {
						type: 'category',
						splitLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLine: {
							show: false
						},
						data: xline,
						axisLabel: {
							fontSize: 13,
							fontWeight: 'bold',
							color: '#333',
						}
						
					},
					series: [{
						data: seriesline,
						type: 'bar',
						barWidth:25,
					}]
				};
				chart.setOption(option);
					// 根据柱状图y轴的长度 option.yAxis.data.length
					//可以f12调试下，我这边是根据option.yAxis.data[0].length 获取绑定数据集的长度，每个大概30px 
					var autoHeight = option.yAxis.data.length * 45 + 100;
					chart.getDom().style.height = autoHeight + "px";
					chart.getDom().childNodes[0].style.height = autoHeight + "px";
					chart.getDom().childNodes[0].childNodes[0].setAttribute("height", autoHeight);
					chart.getDom().childNodes[0].childNodes[0].style.height = autoHeight + "px";
					//根据窗口的大小变动图表
					chart.resize();
			},
		sortKey(array, key) {//正序从大到小
			return array.sort(function (a, b) {
				var x = a[key];
				var y = b[key];
				return ((x > y) ? -1 : (x < y) ? 1 : 0)
			})
		},
		mapGeo(el, data, scdata) {
			let myChart = echarts.init(document.getElementById(el));
			let mapUrl = this.mapurl;
			let mapUnit = this.mapUnit;
			let _this = this;
			let minnum = 0, maxnum = 10;
			for (let i = 0; i < data.length; i++) {
				let value1 = data[i].value + 10;
				maxnum = maxnum > value1 ? maxnum : value1;
			}
			let hovercolor = ['#c7ddf7', '#3887e1'];
			console.log('本地产业链地图数据', data, mapUrl);
			var tootlips = this.public_tooltip;
			$.getJSON(mapUrl, function (geoJson) {
				echarts.registerMap('taizhou', geoJson);
				myChart.hideLoading();
				var option = {
					backgroundColor: 'rgba(0,0,0,0)',
					title: { text: this.title, left: 80, top: 20, textStyle: { color: '#666', fontSize: 18, fontWeight: 700, fontFamily: "Microsoft YaHei" }, },
					tooltip: {
						trigger: 'item',
						backgroundColor: 'rgba(255,255,255,0.7)',
						borderColor: '#ddd',
						borderWidth: '1',
						padding: 0,
						textStyle: {
							color: '#333',
						},
						formatter: function (b, c) {
							var vals = b.value;
							var names = b.name;
							if (vals > 0 && vals != NaN) {
								return '<div class="map-tooltip"><h5>' + names + '：</h5><p class="bluepoint">' + vals + mapUnit + '</p></div>'
							} else {
								return "";
							}
						}
					},
					toolbox: {
						show: false,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							dataView: {
								readOnly: false
							},
							restore: {},
							saveAsImage: {}
						},
						iconStyle: {
							normal: {
								color: '#333'
							}
						}
					},
					animationDuration: 1000,
					animationEasing: 'cubicOut',
					animationDurationUpdate: 1000,
					visualMap: {
						show: true,
						left: 0,
						bottom: 40,
						min: minnum,
						max: maxnum,
						text: ['高', '低'],
						realtime: false,
						itemHeight: 100,
						orient: 'horizontal',
						calculable: false,
						show: false,
						inRange: {
							color: hovercolor,
						}
					},
					geo: {
						map: 'taizhou',
						layoutSize: '100%',
						silent: true,
						itemStyle: {
							normal: {
								areaColor: 'rgba(0,0,0,.5)',
								// shadowColor: 'rgba(0, 0, 0, 1)',
								// shadowBlur: 0,
								// shadowOffsetX: 0,
								// shadowOffsetY: 1,
								borderColor: 'rgba(0, 0, 0, 0.7)',
								borderWidth: 0.5,
							},
							emphasis: {
								areaColor: 'rgba(0,0,0,0)',
								borderWidth: 1,
								color: 'green',
								label: {
									show: false,
								},
							},
						},
					},
					series: [{
						type: 'map',
						map: 'taizhou',
						roam: false,
						data: data,
						label: {
							normal: {
								show: false,
								textStyle: {
									color: '#333',
								},
							},
							emphasis: {
								label: {
									show: false,
								},
								textStyle: {
									color: '#333',
								},
							},
						},
						itemStyle: {
							normal: {
								borderColor: '#fff',
								// borderWidth: 1,
								areaColor: "#ddd",
								// shadowColor: '#96aece',
								// shadowBlur: 0,
								// shadowOffsetX: 0,
								// shadowOffsetY: 1,
							},
							emphasis: {
								areaColor: "#ff0",
								borderColor: '#fff',
								// borderWidth: 1,
								// shadowColor: '#96aece',
								// shadowBlur: 10,
								// shadowOffsetX: 2,
								// shadowOffsetY: 1,
								label: {
									show: true,
								},
							},
						},
					},
					],
				};
				myChart.setOption(option);
			});
		},
		chainFixedBox(nodeid, obj, width, height) {
			var boxoffset = $('.chain-graph-wrap').offset();
			var offsets = $(obj).offset();
			var objWidth = $(obj).children('rect').attr('width') * 1,
				objHeight = $(obj).children('rect').attr('height') * 1;
			var poleft = offsets.left - boxoffset.left + objWidth - 20,
				potop = offsets.top - boxoffset.top + objHeight - 20;
			var hasJiedian = $('.node-' + nodeid).length > 0;
			var datamarket = $('.node-' + nodeid).eq(0).attr('data-market');
			var datanewcompany = $('.node-' + nodeid).eq(0).attr('data-company');
			var datacompany = $('.node-' + nodeid + ' .company_name');
			var htmltablecompany = "",
				htmlnewcompany = "",
				htmlmarket = "";
			var htmls = "",
				htmltable = "",
				boxtitle = [],
				companylink = "",
				companylink1 = "";
			//				console.log($('.node-' + nodeid));
			//					console.log(offsets,objWidth,objHeight);
			//console.log(hasJiedian,objWidth);
			if (hasJiedian && objWidth != "NaN") {
				$(obj).css('cursor', 'pointer');
				if (datamarket != undefined && datamarket.length != 0) {
					datamarket = JSON.parse(datamarket);
					for (var i = 0; i < datamarket.length; i++) {
						var dataxy = datamarket[i].data;
						for (var d = 0; d < dataxy.length; d++) {
							if (d == 0) {
								htmltable += '<tr class="trline' + (i + 1) + '"><td rowspan="' + dataxy.length +
									'" class="firstth">' + datamarket[i].name + '</td><td>' + dataxy[0].name +
									'</td><td>' + dataxy[0].datay + '</td></tr>'
							} else {
								htmltable += '<tr class="trline' + (i + 1) + '"><td>' + dataxy[d].name + '</td><td>' +
									dataxy[d].datay + '</td></tr>';
							}
						}
					}
					htmls = '<table border="0" cellspacing="0" cellpadding="0" width="100%">' + htmltable + '</table>';
					boxtitle.push('市场机会评估');
				}
				if ($('.node-' + nodeid + ' .company_name').length > 0 && $('.node-' + nodeid + ' .company_name').eq(0)
					.html() != "") {
					$('.node-' + nodeid + ' .company_name').each(function () {
						companylink = companylink + this.outerHTML;
					});
					if (htmls != "") {
						htmls = htmls +
							'<div class="chaincom-bot"><h3 class="title">重点公司</h3><div class="botcompanybox">' +
							companylink + '</div></div>'
					} else {
						htmls = '<div class="botcompanybox oh">' + companylink + '</div>';
						boxtitle.push('重点公司');
					}

				}
				if (datanewcompany != undefined && datanewcompany.length != 0) {
					eval("var datanewcompany=" + datanewcompany);
					//						datanewcompany=JSON.parse(datanewcompany);   
					for (var i = 0; i < datanewcompany.length; i++) {
						companylink1 += '<a href="' + datanewcompany[i].url +
							'" target="_blank" class="company_name">' + datanewcompany[i].name + '</a>';
					}

					if (htmls != "") {
						htmls = htmls +
							'<div class="chaincom-bot"><h3 class="title">新兴公司</h3><div class="botcompanybox">' +
							companylink1 + '</div></div>';
					} else {
						htmls = '<div class="botcompanybox oh">' + companylink1 + '</div>';
						boxtitle.push('新兴公司');
					}
				}
				//console.log(htmls); 
				if (htmls != "") {
					$('.chain_inportant_company .title').eq(0).text(boxtitle[0]);
					$('.chain_inportant_company .box').html(htmls);
					$('.chain_inportant_company').css({
						'left': poleft + 'px',
						"top": potop + "px"
					}).fadeIn();
				}
			} else {
				$('.chain_inportant_company').fadeOut();
			}
		},
		stargradef(el) {
			var lengs = document.getElementsByClassName('stargrade').length;
			for (var d = 0; d < lengs; d++) {
				var starnum = document.getElementsByClassName('stargrade')[d].getAttribute('data') * 1;
				var graynum = 4 - starnum;
				let html1 = "", html2 = "";
				for (var i = 0; i < starnum; i++) {
					html1 += '<i class="starfull"></i>';
				}
				for (var i = 0; i < graynum; i++) {
					html2 += '<i class="stargray"></i>';
				}
				document.getElementsByClassName('stargrade')[d].innerHTML = html1 + html2;
			}
		},
		keychainpoint(obj, color) {
			$(obj).toggleClass('current');
			var nodeList = $(obj).attr("node").split(','),
				showgreen = $(obj).hasClass('current');
			if (showgreen) {
				gv.setColor(nodeList, '#fff', color, color); //文字颜色，背景色，边框色
			} else {
				gv.setColor(nodeList); //恢复
			}
		},
		//添加删除收藏
		collectFun() {
			// console.log(this.companyinfor.collectId,this.companyinfor);
			this.listToggleCollect(this.chaininformation, 'acoc');
		},
		//添加/取消收藏 
		// collectFun(){
		// 	// console.log(this.chaininformation.collectId,this.chaininformation.collectType);
		// 	var _this=this,cid=this.chaininformation.collectId;
		// 	var ajaxurl="",ajaxdata={};
		// 	if(cid == 0){
		// 	 ajaxurl=this.$api.cyl.collect.add();
		// 		ajaxdata={type:this.chaininformation.collectType,id:this.id}
		// 		}else{
		// 			ajaxurl=this.$api.cyl.collect.remove();
		// 			ajaxdata={collectId:this.chaininformation.collectId};
		// 		} 
		// 	$.ajax({
		// 		type:"POST",
		// 		url:ajaxurl,
		// 		data:ajaxdata,
		// 		headers:{AuthToken:this.userdata.token },
		// 		success:function(res){ 
		// 			if(res.success){
		// 				if(cid == 0){
		// 					_this.chaininformation.collectId=res.data.collectId;
		// 				}else{
		// 					_this.chaininformation.collectId=0;
		// 				} 
		// 			} 
		// 		} 
		// 	}) 
		// }

	}




}
</script>

<style scoped="scoped">
@import url("../../assets/css/chaindetaill.css");
@import url("/css/common-chian.css");

#app {
	height: auto !important;
}

.chain_RelatedReport {
	border-top: 2px solid #eee;
	border-bottom: 2px solid #eee;
}

/* 	.chain-graph-wrap {
		background: #f8f8f8;
	} */
</style>
<style>

.localChain.chanyelian .el-dialog__body {
	padding: 0;
}

.localChain.chanyelian .el-dialog__header {
	padding: 0;
}

.localChain.chanyelian .el-dialog__headerbtn .el-dialog__close {
	color: #f00;
	font-size: 30px;
	line-height: 30px;
	margin-top: -7px;
	border: 2px dashed #f2c86f;
	margin-right: -17px;
}

.localChain .el-dialog__headerbtn .el-dialog__close:hover {
	color: #e27c2b;
}

.localChain.chanyelian .el-dialog {
	background: rgba(0, 0, 0, 0);
	box-shadow: 0 0 0 rgb(0 0 0 / 30%);
}

.localChain .free-usertips-bg0 {
	background: rgba(0, 0, 0, 0);
}

.localChain .freeUserTips-opbg {
	background: rgba(255, 255, 255, 0) !important;
}
</style>